import { useContext, useEffect, useMemo, useRef } from 'react';
import SelectableState from '../../../contexts/local/selectable/SelectableState';
import ProcessContext from '../../../contexts/process/ProcessContext';
import ConfirmSeedingSelection from './ConfirmSeedingSelection';
import EmptyTraySlotSelector from './EmptyTraySlotSelector';
import SeedTypeSelection from './SeedTypeSelection';
import TraySelection from './TraySelection';
import SeedVariantTypeSelection from './SeedVariantTypeSelection';
import Loading from '../../ui-elements/Loading';

const Seeding = () => {
  const { occupancyArray, finishProcess, additionalProcessInformation } = useContext(ProcessContext);
  const completingRef = useRef(false);

  const selectableItems = useMemo(() =>
    occupancyArray.filter(item => item.isAvailable).map(item => item.index),
    [occupancyArray]
  );
  
  const currentProcessStep = additionalProcessInformation?.processStep;
  const tray = additionalProcessInformation?.destinationEntity;
  const seedTypeId = additionalProcessInformation?.seedTypeId;

  useEffect(() => {
    return () => {
      if (!completingRef.current) {
        finishProcess();
      }
    }
  }, []);

  const renderComponentsBasedOnProcessStep = () => {
    if(!currentProcessStep) return <Loading fullScreen={true} />
    switch (currentProcessStep) {
      // HandleTraySelection in SeedingProcess.cs
      case 1:
        return <TraySelection tray={tray} />
      // HandleSeedTypeSelection in SeedingProcess.cs
      case 2:
        return tray ? <SeedTypeSelection /> : <Loading fullScreen={true} />
      // HandleSeedVariantTypeSelection in SeedingProcess.cs
      case 3:        
        return seedTypeId ? <SeedVariantTypeSelection seedTypeId={seedTypeId} /> : <Loading fullScreen={true} />
      // HandleSeedSlotSelection in SeedingProcess.cs 
      case 4:
        return <SelectableState availableItems={selectableItems}>
          <EmptyTraySlotSelector selectedSlots={additionalProcessInformation?.destinationSelection ?? null} />
        </SelectableState>
      // HandleConfirmation in SeedingProcess.cs
      case 5: 
        return <ConfirmSeedingSelection completingRef={completingRef} />
    }
  }

  return <>
    <div id='seeding-container' className='process-container'>
      {renderComponentsBasedOnProcessStep()}
    </div>
  </>
};

export default Seeding;
